import { Inject, Options, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { EventEmitter } from "events";
import ModalBox from "@/shared/components/modal-box/index.vue";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import { PartBResubmissionRequestRequest, PracticeView } from "@/shared/modules/typescript-trustapi-client/models";
import store from "@/trust-atcs-app/store";
import { AppInsights } from "@/trust-atcs-app/appInsights";


@Options({
  props: {
    practice: Object,
    actionType: String,
  },
  components: {
    ModalBox,
    LoadingSpinner,
    LoadingIndicator,
    ErrorIndicator,
  }
})
export default class ActionModal extends Vue {
  private practice!: any;
  private actionType!: string;

  private loadingContent = false;
  private errorLoadingContent = false;
  private isSaving = false;

  private savingText = 'Saving...';

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private fileList: any[] = [];
  private selectedFileForPreview: any = {};
  private blob: any;
  private documentURL: string = null as any;

  private isAbsolvedPartA = false;
  private isDisabledPartA = false;
  private isAbsolvedPartB = false;
  private isDisabledPartB = false;
  private isAbsolvedEeReport = false;
  private isDisabledEeReport = false;

  private comments = '';

  @Watch('isAbsolvedPartA')
  private onIsAbsolvedPartAChanged(value: boolean): void {
    this.setCheckboxes('a');
  }

  @Watch('isAbsolvedPartB')
  private onIsAbsolvedPartBChanged(value: boolean): void {
    this.setCheckboxes('b');
  }

  @Watch('isAbsolvedEeReport')
  private onIsAbsolvedEeReportChanged(value: boolean): void {
    this.setCheckboxes('c');
  }

  private setCheckboxes(a: string): void {
    switch (a) {
      case 'a':
        if (this.isAbsolvedPartA) {
          this.isAbsolvedPartB = true;
          this.isDisabledPartB = true;
          this.isAbsolvedEeReport = true;
          this.isDisabledEeReport = true;
        } else {
          this.isAbsolvedPartB = false;
          this.isDisabledPartB = false;
          this.isAbsolvedEeReport = false;
          this.isDisabledEeReport = false;
        }
        break;
      case 'b':
        if (this.isAbsolvedPartB) {
          this.isAbsolvedEeReport = true;
          this.isDisabledEeReport = true;
        } else {
          this.isAbsolvedEeReport = false;
          this.isDisabledEeReport = false;
        }
        break;
      case 'c':
      // if (this.isAbsolvedEeReport) {
      //   this.isAbsolvedPartA = true;
      //   this.isDisabledPartA = true;
      //   this.isAbsolvedPartB = true;
      //   this.isDisabledPartB = true;
      // } else {
      //   this.isAbsolvedPartA = false;
      //   this.isDisabledPartA = false;
      //   this.isAbsolvedPartB = false;
      //   this.isDisabledPartB = false;
      // }
      // break;
    }

  }

  mounted(): void {
    if (this.actionType === 'file-attachment') {
      this.getFiles();
    }
    this.isAbsolvedPartA = this.practice.isAbsolvedPartA;
    this.isAbsolvedPartB = this.practice.isAbsolvedPartB;
    this.isAbsolvedEeReport = this.practice.sAbsolvedEeReport;
  }

  private async getFiles(): Promise<void> {
    this.loadingContent = true;
    await this.apiService.ComplianceFormApi?.apiV2ComplianceFormAdminGetComplianceFormFilesComplianceFormIdGet(
      this.practice.id
    )
      .then(res => {
        this.fileList = res.data as any;
        this.loadingContent = false;
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to load file list');
        this.ai.trackException('Error getting load file list: ' + err);
        this.loadingContent = false;
        this.errorLoadingContent = true;
      })
  }


  private closeModal(): void {
    this.$emit('closeModal');
  }

  private confirm(actionType: string): void {
    switch (actionType) {
      case 'resubmit-part-a':
        this.resubmitPartA();
        break;
      case 'resubmit-part-b':
        this.resubmitPartB();
        break;
      case 'absolution':
        this.resubmitEEReport();
        break;
    }

  }

  get practiceName(): string {
    return this.practice.practice?.tradingName ? this.practice.practice.tradingName : this.practice.practice?.name;
  }

  private async resubmitPartA(): Promise<void> {
    // const body: PartAResubmissionRequestRequest = {
    //   partAId: this.practice.partA.id,
    //   comment: this.comments
    // }
    // await this.apiService.PartAFormApi?.apiV2PartAFormAdminSavePartAResubmissionRequestPost(body)
    //   .then(res => {
    //     this.eventCtrl.emit('show-snackbar', 'success', 'Part A resubmission request sent');
    //     setTimeout(() => {
    //       this.$emit('reloadData');
    //       this.closeModal();
    //     }, 500);
    //   })
    //   .catch(err => {
    //     this.eventCtrl.emit('show-snackbar', 'error', 'Unable to resubmit Part A');
    //     this.ai.trackException('Error resubmitting Part A: ' + err);
    //   })

  }

  private async resubmitPartB(): Promise<void> {
    this.isSaving = true;
    const body: PartBResubmissionRequestRequest = {
      partBId: this.practice.partB.id,
      comment: this.comments
    }
    await this.apiService.EeReportApi?.apiV2EeReportSavePartBResubmissionRequestPost(body)
      .then(res => {
        this.eventCtrl.emit('show-snackbar', 'success', 'Part B resubmission request sent');
        setTimeout(() => {
          this.$emit('reloadData');
          this.closeModal();
          this.isSaving = false;
        }, 500);
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to resubmit Part B');
        this.ai.trackException('Error resubmitting Part B: ' + err);
        this.isSaving = false;
      })
  }

  private async resubmitEEReport(): Promise<void> {
    // const body: ComplianceFormAbsolutionRequest = {
    //   complianceFormId: this.practice.id,
    //   isAbsolvedPartA: this.isAbsolvedPartA,
    //   isAbsolvedPartB: this.isAbsolvedPartB,
    //   isAbsolvedEeReport: this.isAbsolvedEeReport
    // }
    // await this.apiService.ComplianceFormApi?.apiV2ComplianceFormAdminUpdateComplianceFormAbsolutionPost(
    //   body
    // )
    //   .then(res => {
    //     this.eventCtrl.emit('show-snackbar', 'success', 'Absolution sent');
    //     setTimeout(() => {
    //       this.$emit('reloadData');
    //       this.closeModal();
    //     }, 500);
    //   })
    //   .catch(err => {
    //     this.eventCtrl.emit('show-snackbar', 'error', 'Unable to sent absolution');
    //     this.ai.trackException('Error sending absolution: ' + err);
    //   })
  }

  private async downloadFile(file: any) {
    await this.apiService.FileAtcsApi?.apiV2FileAtcsAdminDownloadStreamFileIdGet(
      file.id, { responseType: 'blob' }
    )
      .then((res: any) => {
        this.selectedFileForPreview.FileStream = res.data;
        this.selectedFileForPreview.ContentType = res.headers['content-type'];
        this.selectedFileForPreview.FileName = file.fileName
        this.download();
      })
      .catch((err: any) => {
        this.ai.trackException('Unable to download file ' + err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to download file: ' + err);
      })
  }


  private download() {
    this.blob = new Blob([this.selectedFileForPreview.FileStream], { type: this.selectedFileForPreview.ContentType });
    this.documentURL = window.URL.createObjectURL(this.blob);
    const downloadLink = document.createElement('a');
    const fileName = this.selectedFileForPreview.FileName;
    downloadLink.href = this.documentURL;
    downloadLink.download = fileName as string;
    downloadLink.click();
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

  get showConfirmButton(): boolean {
    return this.actionType === 'resubmit-part-a' || this.actionType === 'resubmit-part-b' || this.actionType === 'absolution';
  }

}

